import ReviewOverlay from "@/components/base/ReviewOverlay";
import {breakpoints} from "@/styles/sizes";
import SelectSearchLocation from "@/components/inputs/SelectSearchLocation";
import styled from "styled-components";
import BackgroundImage from "../../other/BackgroundImage";

const HeroWrapper = styled.div`
    width: 100%;
    height: 650px;
    position: relative;

    @media only screen and (${breakpoints.mobile}) {
        height: 450px;
    }
    
    .content_wrapper{
        padding: 60px 50px;
        z-index: 2;
        position: relative;

        @media only screen and (${breakpoints.mobile}) {
            padding: 20px;
        }    
    }
    
    
`
const ContainerDiv = styled.div`
    margin-bottom: 75px;
    @media only screen and (${breakpoints.mobile}) {
        margin-bottom: 0px;
    }
`;

export default function HomepageHeroSection({reviewOverlayData, backgroundImageUrl, title, searchOptions}){

    return (

        <ContainerDiv className={'container'}>
            <div style={{position: 'relative'}}>
                <BackgroundImage
                    src={backgroundImageUrl}
                >
                <HeroWrapper >
                    {/* Main content */}
                    <div className={'content_wrapper'}>
                        <h1 style={{
                            color: 'white',
                            fontWeight: 400,
                            marginBottom: '50px',
                            fontFamily: 'Playfair Display',
                            fontSize: '54px',
                            lineHeight:'60px',
                        }}>
                            {title}
                        </h1>
                        <div style={{
                            maxWidth: '500px',
                            marginTop: '80px',
                        }}>
                            <SelectSearchLocation searchOptions={searchOptions}/>
                        </div>
                    </div>

                    {/* Overlay */}
                    <div style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.35)", // Black color with 50% transparency
                        zIndex: 1, // Lower z-index to ensure it sits below the content
                    }}/>

                    {/* Review overlay for larger screens */}
                        <div className={'desktop_only'} style={{
                            position: "absolute",
                            width: "100%",
                            bottom: 0,
                            left: 0,
                            zIndex: 3, // Ensure this is above everything else
                        }}>
                            <ReviewOverlay data={reviewOverlayData} />
                        </div>
                </HeroWrapper>

                {/* Review overlay for mobile */}
                <div className={'mobile_only'} style={{zIndex: 3}}> {/* Ensure this is above everything else */}
                    <ReviewOverlay data={reviewOverlayData} />
                </div>
                </BackgroundImage>
            </div>
        </ContainerDiv>

    );

}
